
import Utils from 'src/utils/Utils';
import store from 'src/store';
import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import {
    EPG_VERSION_TTL,
    LINEAL_CHANNELS_TTL,
    STATUS_CONTROL_PIN_TTL
} from '../../AAF/Resilence/TTLConstants.js';
import { fetchLinealChannels } from 'src/actions/payway';
import EpgVersionStatus from 'src/utils/EpgVersionStatus';
import ModalPinCode from '../../components/Modal/ModalPinCode';
import { isAndroidDevice } from '../../AAFPersistenceManager/helpers/Utils';
import { IPTV } from '../../devices/all/settings';

let isFirstTime = true;
let secondsTTLData = '';
const updateApp = [];

const setInitialData = () => {
    const time = '60'; // 1661270298000
    const defaultValue = '{"default":{"seconds":' + time + '}}';
    const metadataTTL = Metadata.get('resilence_validate_ttl', defaultValue);
    const objectMeta = JSON.parse(metadataTTL);
    const region = DeviceStorage.getItem('region');
    const value = objectMeta[region] ? objectMeta[region] : objectMeta['default'];

    if (value && typeof value === 'object' && value.seconds && typeof value.seconds !== undefined) {
        secondsTTLData = value.seconds;
    }
}

const isSTB = () => {
    return isAndroidDevice();
}

const addSeconds = (secondsToAdd, time = Utils.nowAsTimestampSeconds()) => {
    const addedTime = time + secondsToAdd;

    return addedTime;
}

const setStorageItemTTL = (item, secondsToAdd = secondsTTLData) => {
    if (isFirstTime) {
        setInitialData();
        isFirstTime = false;
    }
    const { user : { type } = {} } = store.getState();

    if (isSTB() && type === IPTV) {
        const now = Utils.nowAsTimestampSeconds();
        const timeToStorage = addSeconds(secondsToAdd, now);

        console.log('::: TTLUtil[setStorageItemTTL]', item, timeToStorage);
        DeviceStorage.setItem(item, timeToStorage);   
    }
}

const getStorageItemTTL = (item) => {
    return DeviceStorage.getItem(item);
}

const verifyTTLItem = (item, callBack = null, functionFromName = null) => {
    const { user : { type } = {} } = store.getState();

    if (isSTB() && type === IPTV) {
        if (item) {
            const valueFromStorage = getStorageItemTTL(item);
    
            if (valueFromStorage) {
                const itemValue = parseInt(valueFromStorage);
                const now = Utils.nowAsTimestampSeconds();
    
                if (now > itemValue) {
                    console.log("::: TTLUtil[verifyTTL] Call to API", item, functionFromName, "Local Storage:", itemValue, "Now:", now);
                    if (typeof callBack === 'function') {
                        return callBack();
                    }
                }
            }
        }   
    }
    return;
}

const setLinealChannels = () => {
    console.log('::: TTLUtil[setLinealChannels]');
    const user = store.getState().user;

    store.dispatch(fetchLinealChannels(user.user_id, null, true));
    setStorageItemTTL(LINEAL_CHANNELS_TTL);

    return;
}

const setEpgVersion = () => {
    console.log('::: TTLUtil[setEpgVersion]');
    const versionNew = new EpgVersionStatus(updateApp);

    versionNew.checkVersion(true);
    setStorageItemTTL(EPG_VERSION_TTL);

    return;
}

const setStatusControlPin = () => {
    console.log('::: TTLUtil[setStatusControlPin]');
    const newData = new ModalPinCode();

    newData.setBlokedChannels();
    setStorageItemTTL(STATUS_CONTROL_PIN_TTL);

    return;
}

const TTLUtil = {
    setInitialData: setInitialData,
    getStorageItemTTL: getStorageItemTTL,
    setStorageItemTTL: setStorageItemTTL,
    verifyTTLItem: verifyTTLItem,
    setLinealChannels: setLinealChannels,
    setEpgVersion: setEpgVersion,
    setStatusControlPin: setStatusControlPin
};

export { TTLUtil };



// WEBPACK FOOTER //
// ./src/AAF/Resilence/TTLUtil.js